import { createAsyncThunk } from '@reduxjs/toolkit';
import type { HttpError } from '@wix/yoshi-flow-bm';
import { listAdUnits } from '@wix/ambassador-adsense-v1-adsense-adunit/http';
import {
  State,
  type ListAdUnitsResponse,
} from '@wix/ambassador-adsense-v1-adsense-adunit/types';
import { type RootState } from '@app/settings-store';
import { type StoreExtraArgs } from '@app/store/settings/types';
import { selectNextPageToken } from '..';

const DEFAULT_PAGE_SIZE = 10 as const;

export const fetchAdUnitsList = createAsyncThunk(
  'fetchAdUnitsList/GET',
  async (
    _,
    { extra, rejectWithValue, getState },
  ): Promise<ListAdUnitsResponse> => {
    const { httpClient, wixSdk } = extra as StoreExtraArgs;
    const state = getState() as RootState;
    const pageToken = selectNextPageToken(state);

    try {
      const instanceId = wixSdk.getInstanceId();
      const { data } = await httpClient.request(
        listAdUnits({ instanceId, pageSize: DEFAULT_PAGE_SIZE, pageToken }),
      );

      return {
        nextPageToken: data.nextPageToken,
        adUnits:
          data.adUnits?.filter((adUnit) => adUnit.state === State.ACTIVE) ?? [],
      };
    } catch (e) {
      const error = e as HttpError;
      const message = error.response?.data?.message || error.message;
      throw rejectWithValue(message);
    }
  },
);
